import { render, staticRenderFns } from "./Pagination2.vue?vue&type=template&id=08981554&scoped=true"
import script from "./Pagination2.vue?vue&type=script&lang=js"
export * from "./Pagination2.vue?vue&type=script&lang=js"
import style0 from "./Pagination2.vue?vue&type=style&index=0&id=08981554&prod&lang=scss&scoped=true"
import style1 from "./Pagination2.vue?vue&type=style&index=1&id=08981554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08981554",
  null
  
)

export default component.exports